const pendingWidgets = new WeakSet();

const giftWrapNames = {
  "gift-wrap": "Gift Wrapping Service",
  eco: "Eco-Friendly Packaging",
};

function setSignatureInputVisible(widget, visible) {
  widget.querySelector(".signature-input-container").hidden = !visible;
  widget.querySelector('[data-action="gift-wrap-signature-show"]').hidden = visible;
  const input = widget.querySelector("[data-signature-message]");
  if (visible) input.focus();
  else input.value = "";
}

function attributesForAction(button, widget) {
  switch (button.dataset.action) {
    case "gift-wrap-add": {
      const type = button.dataset.giftWrapType;
      if (!Object.hasOwn(giftWrapNames, type)) return;
      return {
        _gift_wrap_type: type,
        _gift_wrap_name: giftWrapNames[type],
        _gift_wrap_description: button.dataset.giftWrapDescription,
      };
    }
    case "gift-wrap-signature-add": {
      const message = widget.querySelector("[data-signature-message]").value.trim();
      return {
        _gift_wrap_type: "signature",
        _gift_wrap_name: message ? "Signature Card with Custom Message" : "Signature Card Service",
        _gift_wrap_description: message || button.dataset.giftWrapDescription,
        _signature_message: message,
      };
    }
    case "gift-wrap-remove":
      return {
        _gift_wrap_type: "",
        _gift_wrap_name: "",
        _gift_wrap_description: "",
        _signature_message: "",
      };
    case "gift-wrap-decline":
      return { _gift_wrap_declined: "true" };
  }
}

document.addEventListener("click", async (event) => {
  const button = event.target.closest("button[data-action]");
  const widget = button?.closest("[data-gift-wrap-widget]");
  if (!widget || !button.dataset.action.startsWith("gift-wrap-")) return;
  event.preventDefault();
  if (pendingWidgets.has(widget)) return;

  if (button.dataset.action === "gift-wrap-signature-show") {
    setSignatureInputVisible(widget, true);
    return;
  }
  if (button.dataset.action === "gift-wrap-signature-hide") {
    setSignatureInputVisible(widget, false);
    return;
  }

  const attributes = attributesForAction(button, widget);
  if (!attributes) return;

  const error = widget.querySelector("[data-gift-wrap-error]");
  const controls = Array.from(widget.querySelectorAll("button, textarea"), (control) => ({
    control,
    disabled: control.disabled,
  }));
  pendingWidgets.add(widget);
  error.hidden = true;
  error.textContent = "";
  widget.setAttribute("aria-busy", "true");
  button.setAttribute("aria-busy", "true");
  controls.forEach(({ control }) => { control.disabled = true; });

  try {
    await window.GlowidCart.updateAttributes(attributes);
  } catch {
    error.textContent = window.themeVariables.strings.gwpCheckoutError;
    error.hidden = false;
  } finally {
    pendingWidgets.delete(widget);
    widget.removeAttribute("aria-busy");
    button.removeAttribute("aria-busy");
    controls.forEach(({ control, disabled }) => { control.disabled = disabled; });
  }
});
